import { WidgetsIdsConnectMain } from '@/widgets/ids-connect';

export const PagesIdsConnectMain = () => <WidgetsIdsConnectMain />;
